import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { HistoryOutlined } from "@mui/icons-material";

import { useFeedbackDetailContext } from "contexts/FeedbackDetailContext";

import HistoryTimeline from "components/Shared/HistoryTimeline";

const FeedbackHistoryTab = () => {
  const { feedbackDetail } = useFeedbackDetailContext();

  const sortedFeedbackHistory =
    [...feedbackDetail?.history]?.sort((a, b) =>
      a?.createdAt > b?.createdAt ? -1 : 1
    ) ?? [];

  return (
    <>
      <Box display="flex" justifyContent="space-between" padding={3}>
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <HistoryOutlined style={{ color: "gray" }} />

          <Typography style={{ fontWeight: 500 }}>History</Typography>
        </Box>
      </Box>

      <Divider />

      <br />

      <HistoryTimeline timelineItems={sortedFeedbackHistory} />
    </>
  );
};

export default FeedbackHistoryTab;
